import withRouteStyles from '../../HOC/withRouteStyles';
import FullScreenPage from './FullScreenPage';

export default withRouteStyles('background')(FullScreenPage);
